import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import { type IService } from '../api/types'

const initialState = {
  service: [] as IService[]
}

export const serviceSlice = createSlice({
  initialState,
  name: 'service',
  reducers: {
    addService: (state, action: PayloadAction<IService>) => {
      state.service.push(action.payload)
    },
    removeService: (state, action: PayloadAction<IService>) => {
      state.service.splice(state.service.findIndex((service) => service.title === action.payload.title), 1)
    }
  }
})

export default serviceSlice.reducer

export const { addService, removeService } = serviceSlice.actions
